import React from 'react'

import { WalletActionWaitPanel } from '@/ui/wallet-action-wait-panel'
import { resolveWalletWaitPresentation } from '@/domain/wallet/resolveWalletWaitPresentation'

type LiquidityReviewWaitProps = {
  attemptingTxn: boolean
  walletProgressPhase: 'wallet' | 'submitted' | null
  txHash?: string
  onCancelWallet: () => void
  reviewDetails: React.ReactNode
}

/** Espera de firma en pantalla review (add/remove liquidez). Cancelación y error tienen pantallas propias. */
export function LiquidityNutrimaticMobileReviewWait({
  attemptingTxn,
  walletProgressPhase,
  txHash,
  onCancelWallet,
  reviewDetails,
}: LiquidityReviewWaitProps) {
  const walletWait = resolveWalletWaitPresentation({
    attemptingTxn,
    walletProgressPhase,
    txHash,
  })

  if (walletWait.kind !== 'idle' && walletWait.waitPhase) {
    return (
      <WalletActionWaitPanel
        phase={walletWait.waitPhase}
        onCancel={walletWait.canCancelWallet ? onCancelWallet : undefined}
        className="nm-mobile-simple__status-block"
      />
    )
  }

  return <>{reviewDetails}</>
}

export function isLiquidityWalletWaitActive(input: {
  attemptingTxn: boolean
  walletProgressPhase: 'wallet' | 'submitted' | null
}): boolean {
  return (
    resolveWalletWaitPresentation({
      attemptingTxn: input.attemptingTxn,
      walletProgressPhase: input.walletProgressPhase,
    }).kind !== 'idle'
  )
}
